/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoveWorkspaceRequest
 */
export interface MoveWorkspaceRequest {
    /**
     * 
     * @type {number}
     * @memberof MoveWorkspaceRequest
     */
    production?: number;
    /**
     * 
     * @type {number}
     * @memberof MoveWorkspaceRequest
     */
    volume?: number;
    /**
     * 
     * @type {string}
     * @memberof MoveWorkspaceRequest
     */
    directory?: string;
}

export function MoveWorkspaceRequestFromJSON(json: any): MoveWorkspaceRequest {
    return MoveWorkspaceRequestFromJSONTyped(json, false);
}

export function MoveWorkspaceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoveWorkspaceRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'production': !exists(json, 'production') ? undefined : json['production'],
        'volume': !exists(json, 'volume') ? undefined : json['volume'],
        'directory': !exists(json, 'directory') ? undefined : json['directory'],
    };
}

export function MoveWorkspaceRequestToJSON(value?: MoveWorkspaceRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'production': value.production,
        'volume': value.volume,
        'directory': value.directory,
    };
}


